// extracted by mini-css-extract-plugin
export default {"button":"_3a9Zl","svg":"_31Q6p"};